import { computed, reactive } from 'vue';
import { authApi } from '@/api/modules';

const sessionState = reactive({
  user: null,
  loaded: false
});

export async function fetchProfile(force = false) {
  if (sessionState.loaded && !force) {
    return sessionState.user;
  }
  try {
    const user = await authApi.profile();
    sessionState.user = user;
    sessionState.loaded = true;
    return user;
  } catch (error) {
    sessionState.user = null;
    sessionState.loaded = true;
    throw error;
  }
}

export function setUser(user) {
  sessionState.user = user;
  sessionState.loaded = true;
}

export function clearSession() {
  sessionState.user = null;
  sessionState.loaded = true;
}

export const currentUser = computed(() => sessionState.user);
export const isAdmin = computed(() => sessionState.user?.role === 'ADMIN');

export { sessionState };
